// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const swalot: PokeData = {
  "id": 317,
  "name": "swalot",
  "height": 17,
  "weight": 800,
  "base_experience": 163,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "pound",
    "body-slam",
    "toxic",
    "sludge",
    "amnesia",
    "poison-gas",
    "sludge-bomb",
    "pain-split",
    "encore",
    "stockpile",
    "spit-up",
    "swallow",
    "yawn",
    "wring-out",
    "gastro-acid",
    "gunk-shot",
    "acid-spray",
    "belch",
    "venom-drench"
  ],
  "moves": [
    "body-slam",
    "poison-gas",
    "sludge-bomb",
    "venom-drench",
    "toxic-overload",
    "purify",
    "acid-rain",
    "poison-fang",
    "toxic-spikes",
    "poison-jab",
    "stun-spore",
    "acid",
    "poison-powder"
  ],
  "evolution_chain": {
    "id": 159,
    "item": null,
    "species": [
      {
        "name": "gulpin",
        "order": 344,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "swalot",
        "order": 345,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 316,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 167,
    "speed": 100,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
